const main = '/Acceptance';
const create = `${main}/create`;
const createNewConfig = `${main}/new-config`;
const editDesks = `${main}/edit-desks`;
const editAddresses = `${main}/edit-addresses`;
const setRoomsFromDate = `${main}/rooms-from-date`;
const changeDesksSettings = `${main}/change-desks-settings`;

export const paths = {
  main,
  create,
  createNewConfig,
  editDesks,
  editAddresses,
  setRoomsFromDate,
  changeDesksSettings,
};
